import { Box, Typography } from '@mui/material';
import { Ongoing, TickInCircleSmall } from '@apigrowfinance/pbolt-icons';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { FormattedMessage, useIntl } from 'react-intl';

import { Resolution } from '@clients/operatorSessionClient';
import accountHistoryStatus from '@messages/accountHistoryStatus';
import getEnumTranslation from '@utils/getEnumTranslation';

const AccountHistoryStatusChip = (
    status: { resolution: Resolution } | null,
) => {
    const { theme } = useTheme();
    const { formatMessage } = useIntl();
    if (status === null) return;

    const statusMsg = getEnumTranslation(status.resolution, {
        messages: accountHistoryStatus,
        formatMessage,
    });

    let icon, textColor: string;

    switch (status.resolution) {
        case 'RESOLVED':
            icon = <TickInCircleSmall fontSize="medium" sx={{ pt: '6px' }} />;
            textColor = theme.palette.success.main;
            break;
        case 'UNRESOLVED':
            icon = (
                <Ongoing
                    fontSize="medium"
                    fill={theme.palette.error.main}
                    sx={{ pt: '4px' }}
                />
            );
            textColor = theme.palette.error.main;
            break;
        case 'OPEN':
            icon = (
                <Ongoing
                    fontSize="medium"
                    fill={theme.palette.text.primary}
                    sx={{ pt: '4px' }}
                />
            );
            textColor = theme.palette.text.primary;
            break;
    }

    return (
        <Box
            component="span"
            width="fit-content"
            data-testid="account-history-status-chip"
            display="flex"
            alignItems="center"
            sx={{
                bgcolor: 'background.default',
                borderRadius: 2,
                px: 1,
                mt: -3,
            }}>
            <Typography
                component="span"
                sx={{
                    fontSize: (theme) => theme.typography.body2.fontSize,
                    fontWeight: (theme) => theme.typography.overline.fontWeight,
                    color: textColor,
                }}
                display="flex"
                justifyContent="center"
                alignItems="center">
                {icon}
                <FormattedMessage
                    id={`AccountHistoryStatusChip.${statusMsg.toString()}`}
                    defaultMessage={statusMsg.toString()}
                />
            </Typography>
        </Box>
    );
};

export default AccountHistoryStatusChip;
